export const WORKFLOW_MODAL_TOOLTIP_DEFAULT_LIMIT_CHARS = 16;
